import { useEffect, useState } from "react";
import { useSelector } from "react-redux"
import Select from 'react-select';
import UiRangeSlider from "../common/UiRangeSlider";

const Filter = ({data, fields, setValue, alldata, setItems}) => {

  const minCost = alldata ? Math.min(...alldata.map((item) => item.totalCost)) : 0;
  const maxCost = alldata ? Math.max(...alldata.map((item) => item.totalCost)) : 0;
  const minPrice = alldata ? Math.min(...alldata.map((item) => item.price)) : 0;
  const maxPrice = alldata ? Math.max(...alldata.map((item) => item.price)) : 0;
  const minSquare = alldata ? Math.min(...alldata.map((item) => item.area)) : 0;
  const maxSquare = alldata ? Math.max(...alldata.map((item) => item.area)) : 0;
  const minFloor = alldata ? Math.min(...alldata.map((item) => item.floor)) : 0;
  const maxFloor = alldata ? Math.max(...alldata.map((item) => item.floor)) : 0;

  const auth = useSelector(state => state.auth);
  const [formFields, setFields] = useState({ ...fields })
  const [open, setOpen] = useState(false)

  useEffect(()=>{
    if(data) filtrate();
  },[fields]) 

  const filtrate = () => {

    /*const filteredData = alldata.filter(
      (el) => {
        return (
          //(!fields.clientName.value || el.clientName === fields.clientName.value.value) &&
          //(!fields.manager.value || el.manager === fields.manager.value.label) &&
          (!fields.project.value || el.project === fields.project.value.label) &&
          //(!fields.type.value || el.type === fields.type.value.label) &&
          //(!fields.status.value || el.status === fields.status.value) &&
          //(!fields.search.value || Object.values(el).filter((item) => typeof item == "string" && item.toLowerCase().indexOf(fields.search.value.toLowerCase()) > -1).length) 
        )
      }
    );
    
    setItems(filteredData);*/

    setItems(alldata);
  };

  const changeValue = (name, value) => {
      setValue({ ...fields, [name]: { ...fields[name], value } })
  }

  const changeRooms = (value) => {
    let index = fields.rooms.value.indexOf(value)
    let val = index >= 0 ? fields.rooms.value.splice(index, 1) : fields.rooms.value.push(value)
    setValue({ ...fields, ['rooms']: { ...fields['rooms'], val } })
  }
    
  const clearFilter = () => {
    setValue({ ...formFields })
  };

  return (
    <div className="filter-block">
      <div>
        <div className="filter-block__column">
          <div className="filter-block__row">
            <div>
              <div class="filter-block__label">Проект</div>
              <Select
                className="select"
                classNamePrefix="select"
                placeholder={'Все'}    
                value={fields.project.value}  
                isSearchable={false}        
                components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                }}
                defaultValue={null}
                onChange={(val) => changeValue('project', val)}  
                options={data ? data.map((item) => ({value: item.projectId, label: item.project})).filter((obj, idx, arr) => idx === arr.findIndex((t) => t.value === obj.value)) : []}
              />
            </div>
            <div>
              <div class="filter-block__label">Локация</div>
              <Select
                className="select"
                classNamePrefix="select"
                placeholder={'Все'}         
                value={fields.location.value}  
                isSearchable={false}        
                components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                }}
                defaultValue={null}
                onChange={(val) => changeValue('location', val)}  
                options={data ? data.map((item) => ({value: item.locationId, label: item.location})).filter((obj, idx, arr) => idx === arr.findIndex((t) => t.value === obj.value)) : []}
              /> 
            </div>
          </div>
          <div className="filter-block__row">
            <div>
              <div class="filter-block__label">Количество комнат</div>
              <div class="filter-rooms">
                {data && data.filter((el) => el.rooms === 'СТ').length > 0  && <div class={fields.rooms.value.indexOf('СТ') >= 0 ? "filter-rooms__item filter-rooms__item_checked" : "filter-rooms__item"} onClick={() => changeRooms('СТ')}>СТ</div>}
                {data && data.filter((el) => el.rooms === 1).length > 0  && <div class={fields.rooms.value.indexOf(1) >= 0 ? "filter-rooms__item filter-rooms__item_checked" : "filter-rooms__item"} onClick={() => changeRooms(1)}>1</div>}
                {data && data.filter((el) => el.rooms === 2).length > 0  && <div class={fields.rooms.value.indexOf(2) >= 0 ? "filter-rooms__item filter-rooms__item_checked" : "filter-rooms__item"} onClick={() => changeRooms(2)}>2</div>}
                {data && data.filter((el) => el.rooms === 3).length > 0  && <div class={fields.rooms.value.indexOf(3) >= 0 ? "filter-rooms__item filter-rooms__item_checked" : "filter-rooms__item"} onClick={() => changeRooms(3)}>3</div>}
                {data && data.filter((el) => el.rooms === 4).length > 0  && <div class={fields.rooms.value.indexOf(4) >= 0 ? "filter-rooms__item filter-rooms__item_checked" : "filter-rooms__item"} onClick={() => changeRooms(4)}>4</div>}
                {data && data.filter((el) => el.rooms >= 5 ).length > 0  && <div class={fields.rooms.value.indexOf(5) >= 0 ? "filter-rooms__item filter-rooms__item_checked" : "filter-rooms__item"} onClick={() => changeRooms(5)}>5+</div>}                  
              </div>                
            </div>                  
            <div>
              <div class="filter-block__label">Срок сдачи</div>
              <Select
                className="select"
                classNamePrefix="select"
                placeholder={'Все'}         
                value={fields.deadline.value}  
                isSearchable={false}        
                components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                }}
                defaultValue={null}
                onChange={(val) => changeValue('deadline', val)}  
                options={data ? data.map((item) => ({value: item.readyDate, label: item.readyDate})).filter((obj, idx, arr) => idx === arr.findIndex((t) => t.value === obj.value)) : []}
              />
            </div>
          </div>
        </div>
        <div className="filter-block__column">
          <div className="filter-block__row">
            <div>
              <UiRangeSlider
                placeholder={"Стоимость, млн. ₽"}
                min={minCost}
                max={maxCost}
                values={fields.cost.value.length != 0 ? fields.cost.value : [minCost, maxCost]}
                onChange={(val) => changeValue("cost", val)}
                name="cost"
              />
            </div>
            <div>
              <UiRangeSlider
                placeholder={"Цена за м², тыс. ₽"}
                min={minPrice}
                max={maxPrice}
                values={fields.price.value.length != 0 ? fields.price.value : [minPrice, maxPrice]}
                onChange={(val) => changeValue("price", val)}
                name="price"
              />
            </div>
          </div>
          <div className="filter-block__row">
            <div>
              <UiRangeSlider
                placeholder={"Площадь, м²"}
                min={minSquare}
                max={maxSquare}
                values={fields.square.value.length != 0 ? fields.square.value : [minSquare, maxSquare]}
                onChange={(val) => changeValue("square", val)}
                name="square"
              />
            </div>
            <div>
              <UiRangeSlider
                placeholder={"Этаж"}
                min={minFloor}
                max={maxFloor}
                values={fields.floor.value.length != 0 ? fields.floor.value : [minFloor, maxFloor]}
                onChange={(val) => changeValue("floor", val)}
                name="floor"
              />
            </div>
          </div>
        </div>
      </div>
      <div className={open ? "filter-block__params-more open" : "filter-block__params-more"}>
        <div className="filter-block__column">
          <div className="filter-block__row">
            <div>
              <div class="filter-block__label">Стороны света</div>
              <Select
                className="select"
                classNamePrefix="select"
                placeholder={'Все'}    
                value={fields.part.value}  
                isSearchable={false}        
                components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                }}
                defaultValue={null}
                onChange={(val) => changeValue('part', val)}  
                options={data ? data.map((item) => ({value: item.compass, label: item.compass})).filter((obj, idx, arr) => idx === arr.findIndex((t) => t.value === obj.value)) : []}
              />
            </div>
            <div>
              <div class="filter-block__label">Преимущества</div>
              <Select
                className="select"
                classNamePrefix="select"
                placeholder={'Все'}         
                value={fields.advantages.value}  
                isSearchable={false}        
                components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                }}
                defaultValue={null}
                onChange={(val) => changeValue('advantages', val)}  
                options={data ? data.map((item) => ({value: item.advantages, label: item.advantages})).filter((obj, idx, arr) => idx === arr.findIndex((t) => t.value === obj.value)) : []}
              /> 
            </div>
            <div>
              <div class="filter-block__label">Отделка</div>
              <Select
                className="select"
                classNamePrefix="select"
                placeholder={'Все'}         
                value={fields.decoration.value}  
                isSearchable={false}        
                components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                }}
                defaultValue={null}
                onChange={(val) => changeValue('decoration', val)}  
                options={data ? data.map((item) => ({value: item.decoration, label: item.decoration})).filter((obj, idx, arr) => idx === arr.findIndex((t) => t.value === obj.value)) : []}
              /> 
            </div>
          </div>
        </div>
        <div className="filter-block__column">
          <div className="filter-block__row">
            <div>
              <div class="filter-block__label">Виды</div>
              <Select
                className="select"
                classNamePrefix="select"
                placeholder={'Все'}         
                value={fields.views.value}  
                isSearchable={false}        
                components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                }}
                defaultValue={null}
                onChange={(val) => changeValue('views', val)}  
                options={data ? data.map((item) => ({value: item.views, label: item.views})).filter((obj, idx, arr) => idx === arr.findIndex((t) => t.value === obj.value)) : []}
              />
            </div>                  
            <div>
              <div class="filter-block__label">Тип</div>
              <Select
                className="select"
                classNamePrefix="select"
                placeholder={'Все'}         
                value={fields.type.value}  
                isSearchable={false}        
                components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                }}
                defaultValue={null}
                onChange={(val) => changeValue('type', val)}  
                options={data ? data.map((item) => ({value: item.type, label: item.type})).filter((obj, idx, arr) => idx === arr.findIndex((t) => t.value === obj.value)) : []}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="filter-block__last">
        <div>
          <div className={open ? "filter-block__more open" : "filter-block__more"} onClick={() => setOpen(!open)}>{open ? 'Меньше' : 'Больше'} параметров</div>
        </div>
        <div className="filter-block__results">найдено {data.length}</div>
        <div>
          <button type="button" className="btn btn_empty btn_small" onClick={clearFilter}>Очистить фильтр</button>
        </div>        
      </div>
    </div>
  )

}

export default Filter